import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CameraFormComponent } from './camera-form.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/index";



@NgModule({
  declarations: [CameraFormComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    PipesModule
  ],
  exports: [CameraFormComponent],
})
export class CameraFormModule { }
